import { AdminExamCenterProctorHeader } from '@exam-center/admin-proctor-management';
import { Outlet } from 'react-router-dom';

export default function AdminProctorsLayout() {
  return (
    <>
      <AdminExamCenterProctorHeader />
      <Outlet />
    </>
  );
}
